export default [
    {
        name: "ownerId",
        label: "Client",
        type: "list",
        url: "/organizations",
        filterValue: "name",
        errorMessage: "Client is required",
        validation: {
            required: true,
        },
        entityName: "owner",
    },
    {
        name: "ownerType",
        hidden: true,
        value: "Organization",
    },
    {
        name: "truckTypeIds",
        label: "Truck Types",
        type: "list",
        url: "/truck-types",
        filterValue: "alias",
        isMultiple: true,
        entityName: "truckType",
        include: false,
        validation: {
            required: true,
        },
    },
    {
        name: "organization",
        label: "Client Name",
        entityName: "organization",
        include: true,
        validation: {
            required: false,
        },
    },
    {
        name: "creator",
        label: "Creator",
        entityName: "creator",
        include: true,
        validation: {
            required: false,
        },
    },
    {
        name: "recurringType",
        label: "Type",
        type: "select",
        data: [
            { value: "monthly_rental", text: "Monthly Rental" },
            { value: "daily_rental", text: "Daily Rental" },
            { value: "on_demand", text: "On Demand" },
        ],
        validation: {
            required: true,
        },
    },
    {
        name: "trucksCount",
        label: "Trucks Count",
        type: "number",
        errorMessage: "Trucks Count is required",
        validation: {
            required: true,
        },
    },
    {
        name: "workingDays",
        label: "Working Days",
        type: "number",
        errorMessage: "Working Days is required",
        validation: {
            required: true,
        },
    },
    {
        name: "workingHoursPerDay",
        label: "Working Hours Per Day",
        type: "number",
        errorMessage: "Working Hours Per Day is required",
        validation: {
            required: true,
        },
    },
    {
        name: "kilometersCount",
        label: "Kilometers Count",
        type: "number",
        errorMessage: "Kilometers Count is required",
        validation: {
            required: true,
        },
    },
    {
        name: "helpersPrice",
        label: "Helpers Price",
        type: "number",
    },
    {
        name: "extraHourPrice",
        label: "Extra Hour Price",
        type: "number",
    },
    {
        name: "extraKilometerPrice",
        label: "Extra Kilometer Price",
        type: "number",
    },
    {
        name: "extraDayPrice",
        label: "Extra Day Price",
        type: "number",
    },
    {
        name: "overnightPrice",
        label: "Overnight Price",
        type: "number",
    },
    {
        name: "representativePrice",
        label: "Representative Price",
        type: "number",
    },
];
